

























































import { Component, Vue } from 'vue-property-decorator'
import { familyLabelFor } from '@/models/sorewardsProgramTypes'
import { listProgramMappings } from '@/services/sorewards/console'
import { ProgramMapping } from '@/services/sorewards/types'

@Component({
  name: 'SorewardsProgramMapping'
})
export default class extends Vue {
  private loading = true
  private rows: ProgramMapping[] = []

  async created() {
    this.loading = true
    try {
      this.rows = await listProgramMappings()
    } finally {
      this.loading = false
    }
  }

  private familyLabel(family: string) {
    return familyLabelFor(
      family,
      (key: string) => String(this.$t(key)),
      (key: string) => this.$te(key)
    )
  }
}
